<div class=" all row between-xs">
    <div class="col-xs-3 col-lg-2">
        <div class="box">
            <div class="row dashleft">
                <div class=" col-xs-offset-3 col-xs-9">
                    <div class="box">offset

                        <div style="display:flex" class="myicon">
                            <div><svg xmlns="http://www.w3.org/2000/svg"
                                    class="icon icon-tabler icon-tabler-brand-tabler" width="44" height="44"
                                    viewBox="0 0 24 24" stroke-width="1.5" stroke="#000000" fill="none"
                                    stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M8 9l3 3l-3 3" />
                                    <line x1="13" y1="15" x2="16" y2="15" />
                                    <rect x="4" y="4" width="16" height="16" rx="4" />
                                </svg></div>
                            <div>dashboard</div>

                        </div>
                        <div style="display:flex" class="myicon">
                            <div><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-book"
                                    width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#000000"
                                    fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0" />
                                    <path d="M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0" />
                                    <line x1="3" y1="6" x2="3" y2="19" />
                                    <line x1="12" y1="6" x2="12" y2="19" />
                                    <line x1="21" y1="6" x2="21" y2="19" />
                                </svg></div>
                            <div>courses</div>

                        </div>
                        <div style="display:flex" class="myicon">
                            <div><svg xmlns="http://www.w3.org/2000/svg"
                                    class="icon icon-tabler icon-tabler-file-invoice" width="44" height="44"
                                    viewBox="0 0 24 24" stroke-width="1.5" stroke="#000000" fill="none"
                                    stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                                    <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
                                    <line x1="9" y1="7" x2="10" y2="7" />
                                    <line x1="9" y1="13" x2="15" y2="13" />
                                    <line x1="13" y1="17" x2="15" y2="17" />
                                </svg></div>
                            <div>Resources</div>

                        </div>
                        <div style="display:flex" class="myicon">
                            <div><svg xmlns="http://www.w3.org/2000/svg"
                                    class="icon icon-tabler icon-tabler-calendar-event" width="44" height="44"
                                    viewBox="0 0 24 24" stroke-width="1.5" stroke="#000000" fill="none"
                                    stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <rect x="4" y="5" width="16" height="16" rx="2" />
                                    <line x1="16" y1="3" x2="16" y2="7" />
                                    <line x1="8" y1="3" x2="8" y2="7" />
                                    <line x1="4" y1="11" x2="20" y2="11" />
                                    <rect x="8" y="15" width="2" height="2" />
                                </svg></div>
                            <div>scedule</div>

                        </div>
                        <div style="display:flex" class="myicon">
                            <div><svg xmlns="http://www.w3.org/2000/svg"
                                    class="icon icon-tabler icon-tabler-message-circle-2" width="44" height="44"
                                    viewBox="0 0 24 24" stroke-width="1.5" stroke="#000000" fill="none"
                                    stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1" />
                                    <line x1="12" y1="12" x2="12" y2="12.01" />
                                    <line x1="8" y1="12" x2="8" y2="12.01" />
                                    <line x1="16" y1="12" x2="16" y2="12.01" />
                                </svg></div>
                            <div>Chat</div>

                        </div>




                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xs-9 col-lg-10">
        <div class="box">
            <div class="row center-xs">
                <div class="col-xs-12 col-lg-12">
                    <div class="box">
                        <div class="mainprof">
                            <div class="">
                                <table class="cardcontent">
                                    <tr>
                                        <td style="padding: 7px;">
                                            <img src="https://i.postimg.cc/SN44cZjp/ken.jpg" width="80" height="80"
                                                class="dp" />
                                            <div class="bluestick"></div>
                                        </td>
                                        <td class="td2">
                                            <strong class="name">Rakesh Chowdhury</strong>
                                            <p class="data">
                                                <span style="color: #666">Kolkata (WB)</span><br>
                                                <a href="https://about.me/rakeshid03"
                                                    class="link">about.me/rakeshid03</a>
                                            </p>

                                            <!-- social media icon-->
                                            <div>

                                                <svg xmlns="http://www.w3.org/2000/svg"
                                                    class="icon icon-tabler icon-tabler-link" width="44" height="44"
                                                    viewBox="0 0 24 24" stroke-width="1.5" stroke="#000000" fill="none"
                                                    stroke-linecap="round" stroke-linejoin="round">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path
                                                        d="M10 14a3.5 3.5 0 0 0 5 0l4 -4a3.5 3.5 0 0 0 -5 -5l-.5 .5" />
                                                    <path d="M14 10a3.5 3.5 0 0 0 -5 0l-4 4a3.5 3.5 0 0 0 5 5l.5 -.5" />
                                                </svg>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>


                            <div class="row" style="display:flex;justify-content: space-between;">
                                <div class="col-xs-4 col-lg-6 dashleft1">
                                    <div class="box">
                                        around
                                    </div>
                                </div>
                                <div class="col-xs-4 col-lg-6 dashleft1">
                                    <div class="box">
                                        <div class="timeline">
                                            <div class="container">


                                                <!--                       
                        <div class="leftbox">
                          <nav>
                            <a id="dashboard"><i class="fas fa-tachometer-alt"></i></a>
                            <a id="profile"> <i class="fas fa-user"></i> </a>
                            <a id="settings"> <i class="fas fa-cog"></i> </a>
                            <a id="messages"> <i class="fas fa-comments"></i> </a>
                            <a id="notification"> <i class="fas fa-bell"></i> </a>
                          </nav>
                        </div> -->
                                                <div class="rightbox">
                                                    <div class="rb-container">
                                                        <div style="font-size: x-large;">
                                                            Recent activities
                                                        </div>
                                                        <ul class="rb">
                                                            <li class="rb-item" ng-repeat="itembx">
                                                                <div class="timestamp">
                                                                    3rd May 2020<br> 7:00 PM
                                                                </div>
                                                                <div class="item-title">Chris Serrano posted a photo on
                                                                    your wall.</div>

                                                            </li>
                                                            <li class="rb-item" ng-repeat="itembx">
                                                                <div class="timestamp">
                                                                    19th May 2020<br> 3:00 PM
                                                                </div>
                                                                <div class="item-title">Mia Redwood commented on your
                                                                    last post.</div>

                                                            </li>

                                                            <li class="rb-item" ng-repeat="itembx">
                                                                <div class="timestamp">
                                                                    17st June 2020<br> 7:00 PM
                                                                </div>
                                                                <div class="item-title">Lucas McAlister just send you a
                                                                    message.</div>

                                                            </li>

                                                        </ul>

                                                    </div>
                                                </div>
                                            </div>

                                            <!-- <div class="col-xs-2">
        <div class="box">
            between
        </div>
    </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>